// Shared export helpers for all modules

export function initPdf() {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit:"mm", format:"a4" });
  const W = 210; const margin = 20; const lineH = 7; let y = 20;
  const goldC = [160,132,92], gray = [100,100,100], dark = [26,26,26];

  const checkY = (h=10) => { if(y+h>280){doc.addPage();y=20;} };
  const heading1 = t => { checkY(12);doc.setFont("helvetica","bold");doc.setFontSize(16);doc.setTextColor(...goldC);doc.text(t,margin,y);y+=10; };
  const heading2 = t => { checkY(10);doc.setFont("helvetica","bold");doc.setFontSize(13);doc.setTextColor(...dark);doc.text(t,margin,y);y+=8; };
  const heading3 = t => { checkY(8);doc.setFont("helvetica","bold");doc.setFontSize(10);doc.setTextColor(...gray);doc.text(t.toUpperCase(),margin,y);y+=6; };
  const body = (t,indent=0) => { if(!t)return;doc.setFont("helvetica","normal");doc.setFontSize(10);doc.setTextColor(...dark);const lines=doc.splitTextToSize(t,W-margin*2-indent);lines.forEach(l=>{checkY();doc.text(l,margin+indent,y);y+=lineH;}); };
  const divider = () => { checkY(6);doc.setDrawColor(220,210,195);doc.line(margin,y,W-margin,y);y+=6; };
  const space = (n=4) => { y+=n; };

  const addHeader = (title, userName) => {
    doc.setFillColor(160,132,92);doc.rect(0,0,W,8,"F");
    doc.setFont("helvetica","italic");doc.setFontSize(9);doc.setTextColor(255,255,255);
    doc.text('"For I know the plans I have for you..." — Jeremiah 29:11',margin,5.5);
    space(6);
    doc.setFont("helvetica","bold");doc.setFontSize(20);doc.setTextColor(...goldC);
    doc.text(title,margin,y);y+=10;
    doc.setFont("helvetica","normal");doc.setFontSize(11);doc.setTextColor(...gray);
    doc.text(`${userName}  ·  Exported ${new Date().toLocaleDateString("en-IN",{day:"numeric",month:"long",year:"numeric"})}`,margin,y);y+=6;
    divider();space(2);
  };

  const addFooters = () => {
    const pages=doc.getNumberOfPages();
    for(let i=1;i<=pages;i++){
      doc.setPage(i);doc.setFont("helvetica","normal");doc.setFontSize(8);doc.setTextColor(180,170,155);
      doc.text("My Self-Management Framework",margin,292);
      doc.text(`Page ${i} of ${pages}`,W-margin,292,{align:"right"});
    }
  };

  return { doc, margin, W, y:()=>y, setY:(v)=>{y=v;}, checkY, heading1, heading2, heading3, body, divider, space, addHeader, addFooters };
}

export function downloadExcel(sheets, filename) {
  const wb = window.XLSX.utils.book_new();
  sheets.forEach(({ name, data }) => {
    const ws = window.XLSX.utils.aoa_to_sheet(data);
    window.XLSX.utils.book_append_sheet(wb, ws, name);
  });
  window.XLSX.writeFile(wb, filename);
}
